import * as React from "react";
import { DataTable } from "components/DataTable/DataTable";
import { AiServiceUsageReport, AiServiceUsageReportItem } from "gen/clients";
import { ApiErrorMessage } from "components/ApiErrorMessage/ApiErrorMessage";
import { Stack } from "@mui/material";
import { TokenBasedPaginator } from "components/TokenBasedPaginator/TokenBasedPaginator";
import { formatDate } from "utils/dateUtils";

interface Props {
  data?: AiServiceUsageReport;
  isLoading: boolean;
  error?: unknown;
  rowsPerPage: number;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  onPageTokenChange: (pageToken: string | undefined) => void;
  nextPageToken: string | undefined;
  paginatorResetRef: React.MutableRefObject<() => void>;
}

const AiServiceUsageReportTable: React.FC<Props> = ({
  data,
  isLoading,
  error,
  rowsPerPage,
  onRowsPerPageChange,
  onPageTokenChange,
  nextPageToken,
  paginatorResetRef
}) => {
  return (
    <Stack>
      <DataTable
        isLoading={isLoading}
        error={!!error && <ApiErrorMessage apiError={error} />}
        columns={[
          {
            id: "username",
            title: "User name",
            cell: (row: AiServiceUsageReportItem) => row.username
          },
          {
            id: "requestType",
            title: "Request Type",
            cell: (row: AiServiceUsageReportItem) => row.requestType
          },
          {
            id: "characterCount",
            title: "Character count",
            cell: (row: AiServiceUsageReportItem) => row.characterCount
          },
          {
            id: "sourceLanguage",
            title: "Source Language",
            cell: (row: AiServiceUsageReportItem) => row.sourceLanguage
          },
          {
            id: "targetLanguages",
            title: "Target Languages",
            cell: (row: AiServiceUsageReportItem) => row.targetLanguages
          },
          {
            id: "dateTime",
            title: "Date/Time",
            cell: (row: AiServiceUsageReportItem) => formatDate(row.dateTime)
          }
        ]}
        data={data?.items || []}
        rowKey={(row: AiServiceUsageReportItem) => `${row.username}-${row.dateTime}-${row.characterCount}`}
      />
      <TokenBasedPaginator
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        onPageTokenChange={onPageTokenChange}
        nextPageToken={nextPageToken}
        currentPageDataRows={data?.items.length}
        rowsPerPageOptions={[10, 20, 50, 100]}
        resetRef={paginatorResetRef}
      />
    </Stack>
  );
};

export { AiServiceUsageReportTable };
